import axios from 'axios';

let apiUrl = process.env.API;
if (!apiUrl) {
   const { hostname } = document.location;
   if (hostname === 'localhost' || /\.test$/.test(hostname)) {
      apiUrl = 'http://api.findforsikring.test';
   }
}
export const client = axios.create({
   baseURL: apiUrl,
   withCredentials: true,
   crossDomain: true,
   headers: {
      'X-Requested-With': 'XMLHttpRequest',
   },
});
